import { LoadableLazy } from '@confluence/loadable';

export const EditorConversionModal = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-EditorConversionModal" */ '../src/EditorConversionNotification/EditorConversionModal.tsx'
			)
		).EditorConversionModal,
	name: 'EditorConversionModal',
});
